import { useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { Button, Text } from "../../../../../components/common";
import useRootTranslation from "../../../../../hooks/use-root-translation";
import GroupTable from "./components/group-table/group-table";
import InvitesTable from "./components/group-table/invites-table";
import { Header, SectionContainer, SelectItemContainer, SeletedItem } from "./group-section.styled";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../store/app-state";
import { fetchGroupUsers, fetchInvites } from "../../../../../store/company-profile/company-profile.actions";
import Modal from "../../../../../components/modal/modal";
import LoadingSpinner from "../../../../../components/loading-spinner";

const modalTalent = document.getElementById("modal-talent");

const GroupSection: React.FC<{onClickAdd: () => void}> = ({ onClickAdd }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { user } = useSelector((state: AppState) => state.authState);
    const { removedTeamate } = useSelector((state: AppState) => state.companyProfileState);
    const { root } = useRootTranslation("company-profile.group-section", "private-home-page");
    const [selectedGroup, setSelectedGroup] = useState<boolean>(true);
    const [selectedInvite, setSelectedInvite] = useState<boolean>(false);

    useEffect(() => {
        if (user && user.corporate.id && selectedGroup) {
          dispatch(fetchGroupUsers(user.corporate.id));
        }
    }, [dispatch, user, selectedGroup]);

    useEffect(() => {
        if (user && user.corporate.id && selectedInvite) {
          dispatch(fetchInvites(user.corporate.id));
        }
    }, [dispatch, user, selectedInvite]);
    
    return (
        <SectionContainer>
            <Modal
                width={500}
                target={modalTalent}
                isShown={removedTeamate.loading}
                toggle={() => {}}
                showCloseButton={false}
            >   
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '1rem'
                    }}
                >
                    <LoadingSpinner />
                    <Text
                        color={theme.colors.primaryBlue.main}
                    >
                        {root('removing-user')}
                    </Text>
                </div>
            </Modal>
            <Header>
                <SelectItemContainer>
                    <SeletedItem 
                        selected={selectedGroup} 
                        onClick={() => {
                            setSelectedGroup(true); 
                            setSelectedInvite(false);
                        }}
                    >
                        {root('group-table')}
                    </SeletedItem>
                    <SeletedItem 
                        selected={selectedInvite}
                        onClick={() => {
                            setSelectedGroup(false); 
                            setSelectedInvite(true);
                        }}
                    >
                        {root('invite-table')}
                    </SeletedItem>
                </SelectItemContainer>
                <Button
                    backgroundColor={theme.colors.primaryBlue.main}
                    textColor={theme.colors.primaryBlue.text}
                    width="fit-content"
                    padding="0.5rem 1rem"
                    fontWeight={700}
                    onClick={onClickAdd}
                >
                    {root('add-people')}
                </Button>
            </Header>
            {selectedGroup && <GroupTable />}
            {selectedInvite && <InvitesTable />}
        </SectionContainer>
    )
}

export default GroupSection;
